import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import TagManager from 'react-gtm-module';

import { initSentry, Sentry } from 'sentry';
import App from 'App';
import registerServiceWorker from 'registerServiceWorker';
import 'static/styles/tailwind.css';
import 'static/styles/micro-animations.css';

initSentry();

if (process.env.REACT_APP_GT_KEY) {
  const tagManager = { gtmId: process.env.REACT_APP_GT_KEY };
  TagManager.initialize(tagManager);
}

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element #root not found');
}

ReactDOM.render(
  <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please reload the page.</p>}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Sentry.ErrorBoundary>,
  root
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/Index.tsx